/**
 * Created by Abner, Sui on 09/28/2020
 * -------------------------------------
 */

export enum ImgPreviewActionTypes {
    OPEN = 'OPEN',
}
